import React, {useState} from 'react'
import db from '../firebase'
import {getDatabase, ref, onValue, update} from 'firebase/database'
import {useEffect} from 'react'
import {
	LineChart,
	Line,
	CartesianGrid,
	XAxis,
	YAxis,
	Tooltip,
	Label,
	Legend,
} from 'recharts'
import titleImage from '../images/titleText.png'

function FishFeeder(props) {
	const [buttonColor, setButtonColor] = useState('#ADE0F9')
	const [feedValue, setFeedValue] = useState(1)
	const [feedCheck, setFeedCheck] = useState('')
	const [errorMessage, setErrorMessage] = useState(false)
	const [isModalDisplayed, setIsModalDisplayed] = useState(false)
	const [inProgress, setInProgress] = useState(false)
	const [failed, setFailed] = useState(false)
	// const [temp, setTemp] = useState(0);
	const [tempValues, setWaterTemp] = useState('')
	const [waterLevel, setWaterLevel] = useState([])
	const [screenSize, setScreenSize] = useState(1324)
	const db = getDatabase()

	//GET data from DB
	const getWaterLevel = () => {
		const feedValRef = ref(db, 'aquarium/WaterLevel')
		onValue(feedValRef, (snapshot) => {
			const data = snapshot.val()
			let waterLevelArray = []
			for (let i in data) {
				data[i].timestamp = new Date(
					data[i].timestamp * 1000
				).toLocaleDateString('en-GB')
				waterLevelArray.push(data[i])
			}
			setWaterLevel(waterLevelArray)
		})
	}
	const getWaterTemperature = () => {
		const feedValRef = ref(db, 'aquarium/WaterTemp')
		onValue(feedValRef, (snapshot) => {
			const data = snapshot.val()
			let waterTempArray = []
			for (let i in data) {
				data[i].timestamp = new Date(
					data[i].timestamp * 1000
				).toLocaleDateString('en-GB')
				waterTempArray.push(data[i])
			}
			setWaterTemp(waterTempArray)
		})
	}

	const getFeedVal = () => {
		const feedValue = ref(db, 'aquarium/servo/feed')
		onValue(feedValue, (snapshot) => {
			const data = snapshot.val()
			setFeedCheck(data)
		})
	}

	//POST data to DB
	const postData = (val) => {
		const updates = {}
		updates['/aquarium/servo/feed'] = val

		return update(ref(db), updates)
	}
	useEffect(() => {
		getWaterLevel()
		getWaterTemperature()
	}, [])

	useEffect(() => {
		setScreenSize(Number(window.innerWidth))
	})
	window.addEventListener('resize', setScreenSize)

	const displayModal = () => {
		setInProgress(true)
		setIsModalDisplayed(true)
		setTimeout(() => {
			const feedVal = ref(db, 'aquarium/servo/feed')
			onValue(feedVal, (snapshot) => {
				const data = snapshot.val()
				if (Number(data) === 0) {
					setInProgress(false)
					setFailed(false)
					setTimeout(() => {
						setIsModalDisplayed(false)
					}, 3000)
				} else {
					setInProgress(false)
					setFailed(true)
				}
			})
		}, Number(feedValue) * 5 * 1000 + 2000)
	}
	const setWaterLevelColor = () => {
		const lastWaterLevelValue = Number(
			waterLevel[Object.keys(waterLevel)?.length - 1]?.level
		)
		if (lastWaterLevelValue <= 0 && lastWaterLevelValue >= -2) return 'green'
		else if (lastWaterLevelValue <= -3 && lastWaterLevelValue > -4)
			return '#FADD1F'
		return '#CC0000'
	}
	const setTempColor = () => {
		const lastTempValue = Number(
			tempValues[Object.keys(tempValues)?.length - 1]?.temperature
		)
		if (lastTempValue > 24 && lastTempValue <= 27) return 'green'
		else if (lastTempValue >= 21 && lastTempValue <= 24) return '#FADD1F'
		return '#CC0000'
	}

	return (
		<div
			style={{
				height: '100%',
				backgroundImage: 'linear-gradient(15deg, #13547a 0%, #80d0c7 100%)',
				paddingTop: '2rem',
			}}>
			{isModalDisplayed && (
				<div
					style={{
						backgroundColor: inProgress
							? 'lightgrey'
							: failed
							? 'tomato'
							: '#57E890',
						height: '2rem',
						width: '20rem',
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						padding: '0.3rem 0',
						margin: 'auto',
						borderRadius: '1rem',
					}}>
					{`Feeding ${
						inProgress ? 'in progress' : failed ? 'failed' : 'successful'
					}`}
				</div>
			)}
			<header
				style={{
					display: 'flex',
					flexDirection: 'row',
					justifyContent: 'center',
				}}>
				<img src={titleImage} style={{width: '100vw'}} />
			</header>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					margin: 'auto',
				}}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
					}}>
					<span
						style={{
							fontFamily: 'cursive',
							fontSize: screenSize < 450 ? '1.1rem' : '1.7rem',
						}}>
						Insert quantity:
					</span>
					<input
						style={{
							backgroundColor: 'lightblue',
							margin: '1rem',
							borderColor: 'transparent',
							height: '2rem',
							borderRadius: '1rem',
							paddingLeft: '1rem',
							fontSize: '1.2rem',
							width: '3rem',
						}}
						type='text'
						name='name'
						value={feedValue}
						onChange={(v) => {
							setFeedValue(v.target.value)
						}}
					/>
					<button
						style={{
							width: screenSize < 450 ? '6rem' : '8rem',
							height: '2.5rem',
							backgroundColor: `${buttonColor}`,
							borderColor: '#6030F9',
							borderRadius: '0.6rem',
							fontFamily: 'cursive',
							fontWeight: '700',
							fontSize: '1.2rem',
						}}
						onMouseLeave={() => {
							setButtonColor('#ADE0F9')
						}}
						onMouseEnter={() => {
							setButtonColor('#7ECCF3')
						}}
						onClick={() => {
							if (feedValue < 10 && feedValue > 0) {
								setErrorMessage(false)
								postData(Number(feedValue))
								displayModal()
							} else {
								setErrorMessage(true)
								setFeedValue('')
							}
						}}>
						Feed
					</button>
				</div>
				{errorMessage && (
					<div style={{color: '#032CF7', fontSize: '17px', fontWeight: '500'}}>
						Please choose a number between 1 and 9
					</div>
				)}
			</div>
			<div
				style={{
					marginTop: '3rem',
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					paddingBottom: '3rem',
				}}>
				<div
					style={{
						fontSize: screenSize < 450 ? '1.15rem' : '2rem',
						textAlign: screenSize < 450 ? 'center' : '',
						color: 'black',
						fontFamily: 'cursive',
						paddingBottom: '2rem',
					}}>
					{`Water level is           `}
					<span
						style={{
							color: setWaterLevelColor(),
							borderBottom: `3px solid ${setWaterLevelColor()}`,
						}}>
						{`${Math.abs(
							waterLevel[Object.keys(waterLevel)?.length - 1]?.level
						)} cm under maximum level `}
					</span>
					<span>
						at {waterLevel[Object.keys(waterLevel)?.length - 1]?.timestamp}
					</span>
				</div>
				<div
					style={{
						fontSize: '2rem',
						color: 'black',
						fontFamily: 'cursive',
						paddingBottom: '1rem',
						fontSize: screenSize < 450 ? '1.15rem' : '2rem',
						textAlign: screenSize < 450 ? 'center' : '',
					}}>
					{`Water temperature is           `}
					<span
						style={{
							color: setTempColor(),
							borderBottom: `3px solid ${setTempColor()}`,
						}}>
						{`${Math.abs(
							tempValues[Object.keys(tempValues)?.length - 1]?.temperature
						)} °C `}
					</span>
					<span>
						at {tempValues[Object.keys(tempValues)?.length - 1]?.timestamp}
					</span>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					paddingBottom: '3rem',
				}}>
				<LineChart
					width={1200}
					height={400}
					data={waterLevel}
					style={{
						backgroundColor: 'lightblue',
						borderRadius: '1rem',
						padding: '10px',
						overflow: screenSize < 900 ? 'scroll' : 'visible',
					}}>
					<Line type='monotone' dataKey='level' stroke='red' />
					<CartesianGrid stroke='#888' strokeDasharray='5 5' />
					<XAxis
						dataKey='timestamp'
						stroke='black'
						angle={30}
						tickMargin='20'
						height={90}>
						<Label
							value='Measurement date'
							offset={0}
							position='insideBottom'
						/>
					</XAxis>
					<YAxis stroke='black' width={90}>
						<Label value='Water level in cm ( max level = 0 )' angle={-90} />
					</YAxis>
					<Legend
						verticalAlign='top'
						height={36}
						payload={[
							{
								value: 'Water level evolution in time',
								color: '#AC1616',
								type: 'line',
							},
						]}
					/>
					<Tooltip />
				</LineChart>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					paddingBottom: '3rem',
				}}>
				<LineChart
					width={1200}
					height={400}
					data={tempValues}
					style={{
						backgroundColor: 'lightblue',
						borderRadius: '1rem',
						padding: '10px',
						overflow: screenSize < 900 ? 'scroll' : 'visible',
					}}>
					<Line
						type='monotone'
						dataKey='temperature'
						stroke='red'
						dot={true}
						activeDot={true}
					/>
					<CartesianGrid stroke='#888' strokeDasharray='5 5' />
					<XAxis
						dataKey='timestamp'
						stroke='black'
						angle={30}
						tickMargin='20'
						height={90}>
						<Label
							value='Measurement date'
							offset={0}
							position='insideBottom'
						/>
					</XAxis>
					<YAxis stroke='black' width={90}>
						<Label value='Water temperature in Celsius' angle={-90} />
					</YAxis>
					<Legend
						verticalAlign='top'
						height={36}
						payload={[
							{
								value: 'Water temperature',
								color: '#AC1616',
								type: 'line',
							},
						]}
					/>
					<Tooltip />
				</LineChart>
			</div>
		</div>
	)
}

export default FishFeeder
